import React from 'react'

import { Spinner } from 'reactstrap'

export const Login = () => {

    return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: "100%"}}>
                <Spinner color="info" style={{ width: '5rem', height: '5rem' }}/>
            </div>
}